<script setup lang="ts">
import RegisterModal from '@/components/Common/RegisterModal.vue';
import { formatDateTime } from '@/services/functions';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: boolean
  title: string
  message: string
  changeValues: string[]
  execFunction: () => void
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function changeFormat(dateTime: string | null) {
  return dateTime ? formatDateTime(new Date(dateTime)) : '';
}

function exec() {
  props.execFunction();
  modelValue.value = false;
}
</script>
<template>
  <RegisterModal
    v-model="modelValue"
    modalMaxWidth="45%"
    width="20%"
    :title="props.title"
  >
    <template v-slot:content>
      <div class="w-100">
        <div class="d-flex justify-content-center my-4">
          {{ props.message }}
        </div>
        <div class="d-flex justify-content-center">
          <span class="text-title-large">{{ changeFormat(props.changeValues[0]) }}</span>
          <span class="material-symbols-outlined mx-2">
            arrow_right
          </span>
          <span class="text-title-large font-weight-bold">{{ changeFormat(props.changeValues[1]) }}</span>
        </div>
      </div>
    </template>
    <template v-slot:buttons>
      <v-btn
        class="ma-2 reset-btn"
        @click="modelValue = false"
      >
        {{ i18n.global.t('common.cancelBtn') }}
      </v-btn>
      <v-btn
        class="ma-2 exec-btn"
        @click="exec"
      >
        {{ i18n.global.t('pages.dailyReports.alterLeavingOrReturning.execute') }}
      </v-btn>
    </template>
  </RegisterModal>
</template>
